import type { FaireProductEntity } from "../../entity_types/product";

export const p_swmqfjp79h: FaireProductEntity = {
  token: "p_swmqfjp79h",
  type: "product",
  name: "Big Wave Hand & Nail Cream",
  brandToken: "b_aab41222",
  brandName: "Artifact",
  imageUrl:
    "https://cdn.faire.com/fastly/4153df7d05374b566da6852b972da0be66f359161e65739ab2b08ec87a82a3c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5276856db2bf3a2f99d081f091eaff08d7146563ca7c7ce22e1794d4b4564bd5.jpeg",
    "https://cdn.faire.com/fastly/3a7550d169e3cab8b15f1f953d49e43f04c9f7943ae4a88abcb57758ac03347d.jpeg",
    "https://cdn.faire.com/fastly/b3cc5f58968fb4a9bc7e3a7247ff624b0f8814a1ade5eae2fed0d8ed90df853d.jpeg",
    "https://cdn.faire.com/fastly/7bda74a7aba93b4db68ae7baeb1fa27ed602f5018dd4763c5f93deac24b2f193.jpeg",
    "https://cdn.faire.com/fastly/574abeb4e00064162004fec9f7d71cdf87b795e6fe7a9ff686e20a094c0be2c8.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "Rosemary Leaf - Rosewood - Lime Rind \n\nFirm & Restore\nA delicate, non-greasy formula infused with omega-rich Cupuaçu Butter and botanical extracts from Sea Kelp and Green Tea helps to soften, firm, and nourish the skin. Enriched with Beta-Carotene and Vitamin E, this cream is designed to condition and restore dry hands and nails from repeated washing. \n\nScent Profile: Washing over you like a fresh ocean wave, awakening your senses with the herbal and citrusy energy of the sea, while the gentle presence of Rosewood adds depth and warmth, making it a perfect balance of vitality and comfort.\n\n65 mL / 2.2 fl.oz\n\nPackaging is made of aluminium that is 100% recyclable. This material can be recycled repeatedly without losing quality. ",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:30:24.233Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
